import request from '@/utils/request'

export default {
    createAccount: async({ dispatch }, user) => {
        await request({ method: 'post', url: '/account/create', data: user })
            .then(res => {
                if (res.data && res.data.type) {
                    if (res.data.type !== 'admin') {
                        dispatch('addMessage', {
                            message: 'register',
                            type: 'success',
                            locale: true
                        }, { root: true })
                    } else {
                        dispatch('addMessage', {
                            message: 'registerAdmin',
                            type: 'success',
                            locale: true
                        }, { root: true })
                    }
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.statusDescription) {
                    dispatch('addMessage', {
                        message: err.response.data.statusDescription,
                        status: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    }
}
